document.addEventListener('DOMContentLoaded', () => {
  // Simple cart drawer animations
  function setupCartDrawerAnimations() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    
    // Setup animation order attributes for staggered fade-in
    function setupAnimationOrder() {
      // Setup cart items animation order
      const cartItems = cartDrawer.querySelectorAll('.cart-item');
      cartItems.forEach((item, index) => {
        item.style.setProperty('--animation-order', index);
      });
      
      // Setup additional elements animation index
      const cartBlocks = cartDrawer.querySelectorAll('.cart__blocks > *');
      cartBlocks.forEach((block, index) => {
        block.style.setProperty('--animation-index', index);
      });
    }
    
    // Apply animation to shipping progress bar
    function setupShippingBarAnimation() {
      const shippingBar = cartDrawer.querySelector('.free-shipping-bar');
      if (shippingBar) {
        const progressBar = shippingBar.querySelector('.free-shipping-progress-bar');
        if (progressBar) {
          // Ensure progress bar animation works properly
          const progressWidth = progressBar.style.width || '0%';
          progressBar.style.width = '0%';
          
          // Set the actual width after a small delay to ensure animation plays
          setTimeout(() => {
            progressBar.style.width = progressWidth;
          }, 10);
        }
      }
    }
    
    // Setup item removal animation
    function setupRemovalAnimation() {
      cartDrawer.addEventListener('click', (event) => {
        const removeButton = event.target.closest('cart-remove-button');
        if (!removeButton) return;
        
        const cartItem = removeButton.closest('.cart-item');
        if (cartItem) {
          // Add a class to animate the item out
          cartItem.classList.add('cart-item--removing');
          
          // Short delay before actual removal to allow animation to play
          const removeClickHandler = removeButton.querySelector('button')?.onclick;
          if (removeClickHandler) {
            removeButton.querySelector('button').onclick = (e) => {
              e.preventDefault();
              e.stopPropagation();
              
              // Allow time for fade-out animation
              setTimeout(() => {
                if (typeof removeClickHandler === 'function') {
                  removeClickHandler.call(removeButton.querySelector('button'), e);
                }
              }, 300);
            };
          }
        }
      });
    }
    
    // Initialize animations when cart drawer opens
    function initializeEffects() {
      setupAnimationOrder();
      setupShippingBarAnimation();
      setupRemovalAnimation();
    }
    
    // Watch for cart drawer opening
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (cartDrawer.classList.contains('active')) {
            // Cart drawer has opened, initialize effects
            setTimeout(initializeEffects, 100);
          }
        }
      });
    });
    
    observer.observe(cartDrawer, { attributes: true });
    
    // Also initialize on page load in case drawer is already open
    if (cartDrawer.classList.contains('active')) {
      setTimeout(initializeEffects, 100);
    }
  }
  
  // Run setup
  setupCartDrawerAnimations();
  
  // Re-run setup when the cart updates
  document.addEventListener('cart:refresh', () => {
    setTimeout(setupCartDrawerAnimations, 100);
  });
}); 